module.exports = __webpack_public_path__ + "img/product_view_scroll.53579a29.jpg";